// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28Tmm","col":"styles_col__3Va9n"};